// extracted by mini-css-extract-plugin
module.exports = {"Brand":"styles_Brand__nGBuW"};